















class PartUploader {
















  constructor({
    partNumber,
    url,
    blob,
    onComplete,
    onProgress,
    onError
  }) {
    this.bytesUploaded = 0;
    this.xhr = new XMLHttpRequest();
    this.partNumber = partNumber;
    this.uploadUrl = url;
    this.blob = blob;
    this.onComplete = onComplete;
    this.onProgress = onProgress;
    this.onError = onError;
  }

  /**
   * Upload part by preSigned url
   * @return {Promise<any>}
   */
  uploadPart = () => new Promise((resolve, reject) => {
    this.xhr.open('PUT', this.uploadUrl);

    this.xhr.upload.onprogress = this.onProgressHandler;

    this.xhr.onload = async () => {
      try {
        await this.onLoadedHandler();

        resolve();
      } catch (err) {
        reject(err.message);
      }
    };
    this.xhr.onerror = () => {
      try {
        this.onPartError();
      } catch (err) {
        reject(err.message);
      }
    };

    this.xhr.send(this.blob);
  });

  onProgressHandler = (e) => {
    if (!e.lengthComputable) {return;}

    const prevBytesUploaded = this.bytesUploaded;

    this.bytesUploaded = e.loaded;

    const uploadedNow = e.loaded - prevBytesUploaded;

    this.onProgress(uploadedNow);
  };

  onLoadedHandler = () => {
    if (this.xhr.status !== 200) {
      return void this.onPartError();
    }

    this.onPartSuccess();
  };

  onPartSuccess = () => {
    const etagHeader = this.xhr.getResponseHeader('Etag') || '';

    const part = {
      PartNumber: this.partNumber,
      ETag: etagHeader.replace(/"/g, '')
    };

    this.onComplete(part);
  };

  onPartError = () => {
    this.onError(this.bytesUploaded, this.partNumber);

    this.xhr.abort();

    throw new Error('Part upload error');
  };
}

export default ((part) => new PartUploader(part));